export var VANILLA_TEMPLATE = {
  files: {
    "/src/index.js": {
      code: "import \"./styles.css\";\n\ndocument.getElementById(\"app\").innerHTML = `\n<h1>Hello Vanilla!</h1>\n<div>\n  We use the same configuration as Parcel to bundle this sandbox, you can find more\n  info about Parcel \n  <a href=\"https://parceljs.org\" target=\"_blank\" rel=\"noopener noreferrer\">here</a>.\n</div>\n`;\n"
    },
    "/src/styles.css": {
      code: "body {\n  font-family: sans-serif;\n}\n      "
    },
    "/index.html": {
      code: "<!DOCTYPE html>\n<html>\n\n<head>\n  <title>Parcel Sandbox</title>\n  <meta charset=\"UTF-8\" />\n</head>\n\n<body>\n  <div id=\"app\"></div>\n\n  <script src=\"src/index.js\">\n  </script>\n</body>\n\n</html>"
    }
  },
  dependencies: {},
  entry: "/src/index.js",
  main: "/src/index.js",
  environment: "parcel"
};